var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelsPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#34C759"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0667 8.614C18.0637 7.79533 13.9363 7.79533 9.93333 8.614C8.83314 8.85699 8.03743 9.81459 8 10.9407V12.274C8 13.1945 8.74619 13.9407 9.66667 13.9407H11.6667C12.5871 13.9407 13.3333 13.1945 13.3333 12.274V11.7333C13.3333 11.6455 13.4005 11.5723 13.488 11.5647C15.1598 11.4253 16.8402 11.4253 18.512 11.5647C18.5995 11.5723 18.6667 11.6455 18.6667 11.7333V12.2747C18.6667 13.1951 19.4129 13.9413 20.3333 13.9413H22.3333C22.7754 13.9413 23.1993 13.7657 23.5118 13.4532C23.8244 13.1406 24 12.7167 24 12.2747V10.9413C23.9629 9.815 23.1671 8.85705 22.0667 8.614Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 17.3333C12.9777 17.3333 13.5001 16.811 13.5001 16.1667C13.5001 15.5223 12.9777 15 12.3334 15C11.6891 15 11.1667 15.5223 11.1667 16.1667C11.1667 16.811 11.6891 17.3333 12.3334 17.3333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 20.6673C12.9777 20.6673 13.5001 20.145 13.5001 19.5007C13.5001 18.8563 12.9777 18.334 12.3334 18.334C11.6891 18.334 11.1667 18.8563 11.1667 19.5007C11.1667 20.145 11.6891 20.6673 12.3334 20.6673Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 23.9993C12.9777 23.9993 13.5001 23.477 13.5001 22.8327C13.5001 22.1884 12.9777 21.666 12.3334 21.666C11.6891 21.666 11.1667 22.1884 11.1667 22.8327C11.1667 23.477 11.6891 23.9993 12.3334 23.9993Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 17.3333C16.6443 17.3333 17.1666 16.811 17.1666 16.1667C17.1666 15.5223 16.6443 15 15.9999 15C15.3556 15 14.8333 15.5223 14.8333 16.1667C14.8333 16.811 15.3556 17.3333 15.9999 17.3333Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 20.6673C16.6443 20.6673 17.1666 20.145 17.1666 19.5007C17.1666 18.8563 16.6443 18.334 15.9999 18.334C15.3556 18.334 14.8333 18.8563 14.8333 19.5007C14.8333 20.145 15.3556 20.6673 15.9999 20.6673Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 23.9993C16.6443 23.9993 17.1666 23.477 17.1666 22.8327C17.1666 22.1884 16.6443 21.666 15.9999 21.666C15.3556 21.666 14.8333 22.1884 14.8333 22.8327C14.8333 23.477 15.3556 23.9993 15.9999 23.9993Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 17.3333C20.311 17.3333 20.8333 16.811 20.8333 16.1667C20.8333 15.5223 20.311 15 19.6667 15C19.0223 15 18.5 15.5223 18.5 16.1667C18.5 16.811 19.0223 17.3333 19.6667 17.3333Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 20.6673C20.311 20.6673 20.8333 20.145 20.8333 19.5007C20.8333 18.8563 20.311 18.334 19.6667 18.334C19.0223 18.334 18.5 18.8563 18.5 19.5007C18.5 20.145 19.0223 20.6673 19.6667 20.6673Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 23.9993C20.311 23.9993 20.8333 23.477 20.8333 22.8327C20.8333 22.1884 20.311 21.666 19.6667 21.666C19.0223 21.666 18.5 22.1884 18.5 22.8327C18.5 23.477 19.0223 23.9993 19.6667 23.9993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelsPhone);
export default __webpack_public_path__ + "static/media/ChannelsPhone.29768dab5c433b02fecd2c14e8718cf2.svg";
export { ForwardRef as ReactComponent };